import { useCallback, useEffect, useState } from 'react';
import { ClientStatusError } from '../model/ClientStatusError';
import { useClientStatusContext } from '../context/ClientStatusContext';

type ReturnType = {
  getFieldErrorMessage: (fieldName: string) => string | undefined
  clearAllFieldErrorMessages: () => void,
  clearFieldErrorMessage: (fieldName: string) => void;
  clearArrayFieldErrorMessage: (fieldName: string) => void;
};

export default (): ReturnType => {
  const [fieldErrors, setFieldErrors] = useState<Array<ClientStatusError>>([]);
  const { status } = useClientStatusContext();

  useEffect(() => {
    setFieldErrors(status ? status.fieldErrors : []);
  }, [status]);

  const clearAllFieldErrorMessages = useCallback(() => {
    setFieldErrors([]);
  }, []);

  const clearFieldErrorMessage = useCallback((fieldName: string): void => {
    // this is a callback because of https://stackoverflow.com/a/48731782
    setFieldErrors((prevState) => prevState.filter(error => error.fieldName !== fieldName));
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [fieldErrors]);

  const clearArrayFieldErrorMessage = useCallback((fieldName: string): void => {
    setFieldErrors((prevState) => prevState.filter(error => !error.fieldName?.startsWith(fieldName)));
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [fieldErrors]);

  const getFieldErrorMessage = (fieldName: string): string | undefined => fieldErrors
    .find(error => error.fieldName === fieldName)?.message;

  return {
    getFieldErrorMessage,
    clearAllFieldErrorMessages,
    clearFieldErrorMessage,
    clearArrayFieldErrorMessage,
  };
};
